<template>
  <div @click="itemReady.redirect" class="cursor-pointer">
    <base-image
      :type="itemReady.type"
      image-type="n"
      :file-name="itemReady.logo"
      :profile-id="itemReady.id"
      :project-id="itemReady.id"
      :aspect-ratio="itemReady.aspectRatio"
      :contain="false"
      :imageAlt="`${$t('linked')} ${item.type}: ${item.name}`"
      class="mb-1"
    >
      <template v-slot:loadError>
        <v-sheet :color="itemReady.colors.bg" height="100%" width="100%">
          <v-row
            align="center"
            justify="center"
            style="height : 100%"
            class="ma-0 pa-0"
          >
            <h1
              :style="{
                color: itemReady.colors.text,
                fontSize: '60px'
              }"
            >
              {{ itemReady.name[0] }}
            </h1>
          </v-row>
        </v-sheet>
      </template>
    </base-image>
    <span>{{ itemReady.name }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseImage from '@/components/base_components/BaseImage/BaseImage.vue';

export default {
  components: {
    BaseImage
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState({
      defaultLanguage: state => state.defaultLanguage
    }),

    itemReady() {
      if (!this.item?.name) return {};
      const { logo, name, type } = this.item;

      if (type === 'project')
        return {
          logo,
          name,
          id: this.item.projectId,
          type: 'p',
          aspectRatio: 1,
          colors: this.item.colors,
          redirect: () => {
            this.$router.push({
              name: 'viewSelectedProject',
              params: {
                id: this.item.projectId,
                lang: this.defaultLanguage
              }
            });
          }
        };

      if (type === 'profile')
        return {
          logo,
          name,
          id: this.item.profileId,
          type: 'u',
          aspectRatio: 1,
          redirect: () => {
            this.$router.push({
              name: 'viewProfile',
              params: {
                id: this.item.profileId,
                lang: this.defaultLanguage
              }
            });
          }
        };

      return {
        logo,
        name,
        id: this.item.profileId,
        type: 'u',
        aspectRatio: 25 / 9,
        redirect: () => {
          this.$router.push({
            name: 'viewShowcase',
            params: {
              id: this.item.documentId,
              lang: this.defaultLanguage
            }
          });
        }
      };
    }
  }
};
</script>
